/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 2.15.527 on 2019-07-04 14:53:30.

import { DecisionStatus, DecisionType } from './ais-enum.model';

export class RootResourceIdentifier {
    languageCode: string;
}

export class CaseResourceIdentifier extends RootResourceIdentifier {
    caseId: string;
}

export class LifeResourceIdentifier extends CaseResourceIdentifier {
    lifeInstance: string;
}

export class AdjustmentResourceIdentifier extends LifeResourceIdentifier {
    adjustmentName: string;
}

export class InterviewResourceIdentifier {
    caseId: string;
    interviewCode: string;
    interviewInstance: string;
    languageCode: string;
    lifeInstance: string;
}

export class BaseQuestionIdentifier extends InterviewResourceIdentifier {
    baseQuestionCode: string;
}

export class CaseAttachmentIdentifier {
    attachmentIdentifier: string;
    caseId: string;
    entityIdentifier: CaseResourceIdentifier;
    languageCode: string;
}

export class CaseDecisionIdentifier {
    caseId: string;
    decisionFor: CaseResourceIdentifier;
    decisionStatus: DecisionStatus;
    decisionType: DecisionType;
    languageCode: string;
}

export class CombinationDisclosureIdentifier extends LifeResourceIdentifier {
    combinationName: string;
}

export class ConditionsResourceIdentifier extends InterviewResourceIdentifier {
    categoryCode: string;
    limit: number;
}

export class InterviewDisclosureIdentifier extends InterviewResourceIdentifier {
    aliasName: string;
    baseQuestionCode: string;
}

export class DisclosurePhysicianIdentifier extends InterviewDisclosureIdentifier {
    physicianUuid: string;
}

export class EntityDefinitionIdentifier extends CaseResourceIdentifier {
    entityType: string;
}

export class EvidenceAttachmentIdentifier {
    attachmentIdentifier: string;
    caseId: string;
    entityIdentifier: EvidenceResourceIdentifier;
    languageCode: string;
}

export class EvidenceResourceIdentifier {
    caseId: string;
    evidenceInstance: string;
    evidenceType: string;
    languageCode: string;
    lifeInstance: string;
}

export class EvidenceDisclosureIdentifier extends EvidenceResourceIdentifier {
    disclosureName: string;
}

export class InterviewAttachmentIdentifier {
    attachmentIdentifier: string;
    caseId: string;
    entityIdentifier: InterviewResourceIdentifier;
    languageCode: string;
}

export class LifeAttachmentIdentifier {
    attachmentIdentifier: string;
    caseId: string;
    entityIdentifier: LifeResourceIdentifier;
    languageCode: string;
}

export class LifeDecisionIdentifier {
    caseId: string;
    decisionFor: LifeResourceIdentifier;
    decisionStatus: DecisionStatus;
    decisionType: DecisionType;
    languageCode: string;
}

export class PharmaFillsResourceIdentifier extends EvidenceResourceIdentifier {
    nameDosageKey: string;
}

export class PhysicianResourceIdentifier extends CaseResourceIdentifier {
    uuid: string;
}

export class SingleListIdentifier extends CaseResourceIdentifier {
    readonly listName: string;
}
